console.log('custom-mobile-menu-blog.js loaded');
(function() {
  // 只在手機生效
  function isMobile() {
    return window.innerWidth < 992;
  }

  // Step 1: 先移除主題自帶的所有 click handler
  function removeMenuClickHandler() {
    document.querySelectorAll('a.menu-lv-1__action[href^="/blogs/blog"]').forEach(function(a) {
      // 完全複製新的 a，移除所有 event listener
      var newA = a.cloneNode(true);
      a.parentNode.replaceChild(newA, a);
    });
  }

  // Step 2: 補上我們自己的 click 行為
  function patchBlogMenuHandler() {
    document.querySelectorAll('a.menu-lv-1__action[href^="/blogs/blog"]').forEach(function(a) {
      // 點箭頭展開下拉
      var icon = a.querySelector('.icon-dropdown[data-toggle-menu-mb]');
      if (icon) {
        icon.addEventListener('click', function(e) {
          if (!isMobile()) return;
          e.preventDefault();
          e.stopPropagation();
          var parentLi = a.parentElement && a.parentElement.classList.contains('menu-lv-item') ? a.parentElement : null;
          if (parentLi) parentLi.classList.toggle('is-open');
        });
      }
      // 點主文字直接跳轉
      a.addEventListener('click', function(e) {
        if (!isMobile()) return;
        // 點到箭頭時不跳轉
        if (e.target.closest('.icon-dropdown')) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = a.href;
      });
    });
  }

  // Step 3: 初始化（等 menu 載入完成再 patch，可視需求調整延遲時間）
  function initPatch() {
    removeMenuClickHandler();
    patchBlogMenuHandler();
  }

  // 一般主題 menu 載入常用 setTimeout 1s，若還是不夠可拉長
  setTimeout(initPatch, 1200);

  // 如果主題 menu 會動態重建，建議用 MutationObserver 監聽再補 patch
  // 進階寫法如下，必要時再開啟
  /*
  var observer = new MutationObserver(function() {
    setTimeout(initPatch, 400);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  */
})();